import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Icon from 'common/components/Elements/Icon/Icon';
import React from 'react';

interface ComponentProps {
  title: string;
  text: string;
}

function ExpandableTitleText({ title, text }: ComponentProps) {
  const [showAll, setShowAll] = React.useState(false);

  return (
    <Typography variant="body2">
      {!showAll ? (
        <>
          {title}
          <IconButton onClick={() => setShowAll(true)} size="small" title="Expand">
            <Icon element={AddIcon} />
          </IconButton>
        </>
      ) : (
        <>
          {title}
          <IconButton onClick={() => setShowAll(false)} size="small">
            <Icon element={RemoveIcon} />
          </IconButton>
          <br />
          {text}
        </>
      )}
    </Typography>
  );
}

export default ExpandableTitleText;
